<template>
  <div :class="{ 'add-select': add }">
    <el-select
      v-model="selected"
      size="small"
      filterable
      remote
      clearable
      @change="handleChange"
      :remote-method="requestOptions"
      :loading="loading"
      placeholder="搜索并选择"
      :popper-append-to-body="false"
      :class="{ long: !add }"
      style="width: 100%"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>

    <el-button
      v-if="add"
      type="primary"
      plain
      class="ml-10"
      size="small"
      icon="el-icon-plus"
      @click="addNewOption"
      >新建</el-button
    >
    <NewFormer
      :model="newModel"
      :show.sync="addFormVisible"
      @created="createdCallback"
      :inner="true"
    ></NewFormer>
  </div>
</template>

<script>
import { dealerContactList, createDealerContact } from '../../service/getData'
import NewFormer from '@/components/dealer_contact'

export default {
  components: {
    NewFormer,
  },
  props: {
    value: '',
    dealerID: 0,
    add: false,
    tip: {
      type: String,
      default: '请先选择中间商',
    },
  },
  watch: {
    value: function (v) {
      if (!v) {
        this.selected = ''
      } else if (this.options.length == 0) {
        this.requestDefaultOption()
      }
    },
    dealerID: function (v) {
      this.newModel.dealer_id = v || 0
      if (v) {
        this.requestOptions('all')
      }
    },
  },
  data() {
    return {
      selected: '',
      options: [],
      loading: false,
      addFormVisible: false,
      newModel: {
        dealer_id: this.dealerID,
      },
    }
  },
  created() {
    if (this.value > 0) {
      this.requestDefaultOption()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    handleChange() {
      let selectedIndex = 0
      for (let index = 0; index < this.options.length; index++) {
        if (this.options[index].id == this.selected) {
          selectedIndex = index
          break
        }
      }

      if (this.options[selectedIndex].category == 2) {
        let that = this
        createDealerContact({
          name: this.options[selectedIndex].name,
          mobile: this.options[selectedIndex].mobile,
          dealer_id: this.dealerID,
          category: 2,
        }).then((res) => {
          if (res.code == 0) {
            that.$set(that.options, selectedIndex, res.data)
            that.$nextTick(() => {
              that.selected = res.data.id
              that.$emit('input', parseInt(that.selected) || 0)
            })
          } else {
            that.$emit('input', parseInt(that.selected) || 0)
          }
        })
      } else {
        this.$emit('input', parseInt(this.selected) || 0)
      }
    },
    createdCallback(res) {
      this.options.push(res)
      this.selected = res.id
      this.$emit('input', parseInt(this.selected) || 0)
    },
    addNewOption() {
      if (!this.dealerID) {
        this.$alert(this.tip)
        return
      }
      this.addFormVisible = true
    },
    async requestDefaultOption() {
      let res = await dealerContactList({
        id: this.value,
        dealer_id: this.dealerID || 0,
      })
      this.options = res.data.list
      this.selected = this.value
    },
    async requestOptions(query) {
      if (query !== '') {
        this.loading = true
        query = query == 'all' ? '' : query
        let data = {
          query: query,
          select_option: true,
          dealer_id: this.dealerID || 0,
        }
        let res = await dealerContactList(data)
        this.loading = false
        this.options = res.data.list
      } else {
        this.options = []
      }
    },
  },
}
</script>